/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Nested billing contact from VGS. Send snake_case property names.
 * All properties optional.
 * 
 * @export
 * @interface ApplePayBillingContact
 */
export interface ApplePayBillingContact {
    /**
     * Given name (camelCase givenName also accepted).
     * @type {string}
     * @memberof ApplePayBillingContact
     */
    givenName?: string;
    /**
     * Family name (camelCase familyName also accepted).
     * @type {string}
     * @memberof ApplePayBillingContact
     */
    familyName?: string;
    /**
     * Address lines (camelCase addressLines also accepted).
     * @type {Array<string>}
     * @memberof ApplePayBillingContact
     */
    addressLines?: Array<string>;
    /**
     * City/locality.
     * @type {string}
     * @memberof ApplePayBillingContact
     */
    locality?: string;
    /**
     * State/region (camelCase administrativeArea also accepted).
     * @type {string}
     * @memberof ApplePayBillingContact
     */
    administrativeArea?: string;
    /**
     * Postal code (camelCase postalCode also accepted).
     * @type {string}
     * @memberof ApplePayBillingContact
     */
    postalCode?: string;
    /**
     * ISO country code (camelCase countryCode also accepted).
     * @type {string}
     * @memberof ApplePayBillingContact
     */
    countryCode?: string;
    /**
     * Sub-locality (camelCase subLocality also accepted).
     * @type {string}
     * @memberof ApplePayBillingContact
     */
    subLocality?: string;
}

/**
 * Check if a given object implements the ApplePayBillingContact interface.
 */
export function instanceOfApplePayBillingContact(value: object): value is ApplePayBillingContact {
    return true;
}

export function ApplePayBillingContactFromJSON(json: any): ApplePayBillingContact {
    return ApplePayBillingContactFromJSONTyped(json, false);
}

export function ApplePayBillingContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplePayBillingContact {
    if (json == null) {
        return json;
    }
    return {
        
        'givenName': json['given_name'] == null ? undefined : json['given_name'],
        'familyName': json['family_name'] == null ? undefined : json['family_name'],
        'addressLines': json['address_lines'] == null ? undefined : json['address_lines'],
        'locality': json['locality'] == null ? undefined : json['locality'],
        'administrativeArea': json['administrative_area'] == null ? undefined : json['administrative_area'],
        'postalCode': json['postal_code'] == null ? undefined : json['postal_code'],
        'countryCode': json['country_code'] == null ? undefined : json['country_code'],
        'subLocality': json['sub_locality'] == null ? undefined : json['sub_locality'],
    };
}

export function ApplePayBillingContactToJSON(json: any): ApplePayBillingContact {
    return ApplePayBillingContactToJSONTyped(json, false);
}

export function ApplePayBillingContactToJSONTyped(value?: ApplePayBillingContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'address_lines': value['addressLines'],
        'locality': value['locality'],
        'administrative_area': value['administrativeArea'],
        'postal_code': value['postalCode'],
        'country_code': value['countryCode'],
        'sub_locality': value['subLocality'],
    };
}

